import api from '@/shared/api';

export interface MatrixCategoryOption {
  id: number;
  name: string;
}

export async function listMatrixCategories(): Promise<MatrixCategoryOption[]> {
  const response = await api.get<{ data: MatrixCategoryOption[] }>('/matrix-categories');
  return response.data.data;
}
